import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { HelperService } from "./helper.service";
import { LogoutService } from "./logout.service";
import { UserDataService } from "./user-data.service";

@Injectable()
export class LoginDataProviderService {
  constructor(
    private http: HttpClient,
    private helper: HelperService,
    private userDataService: UserDataService,
    private logoutService: LogoutService
  ) {
    console.log("Login Data Provider");
  }

  load() {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem("acc_tok") && localStorage.getItem("elc")) {
        var headers = new HttpHeaders({
          "X-access-token": localStorage.getItem("acc_tok"),
        });

        const formData = new FormData();
        formData.append("getLoginUserData", "1");

        this.http
          .post(environment.API_URL, formData, {
            headers: headers,
          })
          .subscribe(
            (val: any) => {
              this.userDataService.userData = val;
              this.userDataService.startServerTime(val.time);
              this.logoutService.initTimer();
              resolve(true);
            },
            (error) => {
              if (error.status == 403) {
              }
              resolve(true);
            }
          );
      } else {
        resolve(true);
      }
    });
  }
}
